import script from "./NotificationPanel.vue?vue&type=script&setup=true&lang=ts"
export * from "./NotificationPanel.vue?vue&type=script&setup=true&lang=ts"

import "./NotificationPanel.vue?vue&type=style&index=0&id=1e19af55&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1e19af55"]])

export default __exports__